<template>
	<div class="box-s" :class="{ 'pb-66': !padShow && answer_status != 3,'pb-96': padShow && answer_status != 3, 'pb-132': !padShow && answer_status == 3,  'pb-162': padShow && answer_status == 3 }">
    <!-- 头部 -->
    <div class="ptb-35-34 box-s">
      <div class="w-500 text-center bg_header">
        <div class="c1 fz-20 l-h-20 mb-16" v-if="answer_status == 1 || answer_status == 2">很抱歉你未完成闯关</div>
        <div class="c1 fz-20 l-h-20 mb-16" v-else>恭喜你完成答题</div>
        <div class="c15 fz-16 l-h-16">答题闯关-{{data.gate_level_name}}</div>
      </div>
    </div>

    <div class="plr-17-16 box-s">
      <!-- 时间 -->
      <ul class="flex fw-500">
        <li class="mr-12 b-radius-6 bg_f5 h80 pl-14 c14 flex1">
          <div class="pt-20 box-s l-h-14">
            <span class="fz-18" v-if="day">{{day}}</span>
            <span class="fz-10" v-if="day">天</span>
            <span class="fz-18" v-if="hour">{{hour}}</span>
            <span class="fz-10" v-if="hour">时</span>
            <span class="fz-18">{{minutes}}</span>
            <span class="fz-10">分</span>
            <span class="fz-18">{{second}}</span>
            <span class="fz-10">秒</span>
          </div>
          <div class="fz-12 l-h-12 pt-25">总计用时</div>
        </li>
        <li class="mr-12 b-radius-6 bg_f5 h80 pl-14 c14 flex1">
          <div class="pt-20 box-s l-h-14">
            <span class="fz-18 ">{{data.score}}</span>
            <span class="fz-10">分</span>
          </div>
          <div class="fz-12 l-h-12 pt-25">总分数</div>
        </li>
        <li class=" b-radius-6 bg_f5 h80 pl-14 c14 flex1">
          <div class="pt-20 box-s l-h-14">
            <span class="fz-18 ">{{data.accuracy_percent}}</span>
            <span class="fz-10">%</span>
          </div>
          <div class="fz-12 l-h-12 pt-25">正确率</div>
        </li>
      </ul>

      <div class="h80 b-radius-6 bg_f5 c14 fw-500 pt-20 pl-14 box-s mt-12 mb-25">
        <div class=" l-h-14 fz-18">{{data.study_day}}</div>
        <div class="fz-12 l-h-12 pt-14">练习日期</div>
      </div>

      <div class="pd-20-18-50 b-radius-6 bg_f5 box-s fz-14 fw-500 mb-10">
        <div class="l-h-14 c1 mb-18">标题内容</div>
        <ul class="flex-wrap text-center">
          <li class="wh_36 b-radius-50 l-h-36 mr-18 mb-22" v-for="(item, index) in data.result_arr" :key="index" :class="{ blue: item.is_result == 1, red: item.is_result == 2,  gray: item.is_result == 0 }">{{index + 1}}</li>
          
        </ul>

        <div class="flexs flex-center c0 fz-12 mr-18">
          <div class="flexs mrb-26">
            <div class="wh_8 b-radius-50 bg_49 "></div>
            <div class="ml-8">答对</div>
          </div>
          <div class="flexs mrb-26">
            <div class="wh_8 b-radius-50 bg_3c"></div>
            <div class="ml-8">答错</div>
          </div>

          <div class="flexs">
            <div class="wh_8 b-radius-50 wh_bg9"></div>
            <div class="ml-8">未答</div>
          </div>
        </div>
      </div>
      <div class="fz-12 l-h-12 c3 l-h-14">错题已为您自动加入错题本</div>
      <div class="fz-12 l-h-12 c3 l-h-14">客观题已智能批改，主观题请等待老师批改。</div>
    </div>
    

    <div class="btn_contain">
      <div class="blue_btn mb-16 " @click="getAnalysis" v-if="answer_status == 3">
        查看解析
      </div>

      <div class="card_btn mb-16 " @click="getRepeat">
        重新闯关
      </div>

      <div class="card_btn" @click="$router.replace('/index')">
        返回首页
      </div>
    </div>
    <loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { gateLevelHistoryReport } from '@/api/api';
	import {getShowPadding} from "@/utils/common.js";
	export default {
		components: {
      loading
		},
		data() {
			return {
				padShow: false,
        list: [],
        answer_status: 0,
        data: {},
        day: '',
        hour: '',
        minutes:'',
        second: '',
        loadFlag: false
			};
		},
		created() {
      this.answer_status = this.$route.query.answer_status?this.$route.query.answer_status:3
      if(this.$route.query.form){
        this.data = JSON.parse(this.$route.query.form)
        this.getTime(this.data.time_diff)
      } else {
        this.initData()
      }
      
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
			async initData(){
        this.loadFlag = true
        const res = await gateLevelHistoryReport({ gate_level_user_id: this.$route.query.id })
        this.loadFlag = false
        if(res.code == 1000){
          this.data = res.data
          this.getTime(this.data.time_diff)
          if(this.data.time_diff.indexOf('-') == -1){
            this.minutes = '00'
            this.second = this.data.time_diff < 10? '0' + this.data.time_diff: this.data.time_diff
          } else {
            let arr = this.data.time_diff.split('-')
            const length = arr.length
            this.minutes = arr[length - 2] < 10? '0'+arr[length - 2]:arr[length - 2]
            this.second = arr[length - 1] < 10? '0'+arr[length - 1]:arr[length - 1]
            this.hour = arr.length > 2? (arr[length - 3]<10? '0' + arr[length - 3]:arr[length - 3]) : ''
            this.day = arr.length > 3? (arr[length - 4]<10? '0' + arr[length - 4]:arr[length - 4]) : ''
          }
        } else {
            this.$toast(res.msg)
          }
      },

      getTime(time){
        if(time.indexOf('-') == -1){
          this.minutes = '00'
          this.second = time < 10? '0' + time: time
        } else {
          let arr = time.split('-')
          const length = arr.length
          this.minutes = arr[length - 2] < 10? '0'+arr[length - 2]:arr[length - 2]
          this.second = arr[length - 1] < 10? '0'+arr[length - 1]:arr[length - 1]
          this.hour = arr.length > 2? (arr[length - 3]<10? '0' + arr[length - 3]:arr[length - 3]) : ''
          this.day = arr.length > 3? (arr[length - 4]<10? '0' + arr[length - 4]:arr[length - 4]) : ''
        }
      },

      // 重新闯关
      getRepeat(){
        this.$router.replace({ path: '/passstartquset', query: {id: this.$route.query.cid,time_limit: this.$route.query.time_limit, gate_level_user_id: this.$route.query.id} })
        
      },
      
      // 查看解析
      getAnalysis(){
        this.$router.replace({ path: '/passanalysis', query: { gate_level_user_id: this.$route.query.id } })
      }

		}
	};
</script>
<style lang="less" scoped>

.wh_bg9{
  background: #FFFFFF;
  border: 1px solid #999;
}

.wh_bg3 {
  background: #FFFFFF;
  border: 1px solid #333;
}

.cf {
	
	box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 1);
}

.c4cff {
  color: #497CFF !important;
}

.bg_header {
  width: 253px;
  height: 111px;
  background: url('../../assets/img/bg/report_bg.png') no-repeat;
  background-size: 100%;
  margin: 0 auto;
  padding-top: 29px;
  box-sizing: border-box;
}

.pb-232{
  padding-bottom: 232px;
}
</style>
